import { ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';

const removeAllFrontAccessoriesInScene = ({ coreApi }: BehaviorParameters) => {
  const frontAccessories = coreApi.entities.getByProductTypes([
    ProductType.SMASTAD_MIRROR,
    ProductType.SMASTAD_HOOK_CLIP,
    ProductType.SMASTAD_LABEL_HOLDER
  ]);
  coreApi.entities.deleteMultiple(frontAccessories);
};

export default removeAllFrontAccessoriesInScene;
